import { createContext } from "react";
import { contextFunctionInit } from "sprint-common-web";

import { SystemItem } from "../listing/SystemItem";

interface ISystemContext {
    systemItems: SystemItem[];
    isLoading: boolean;
    addSystemItem(systemItems: SystemItem): void;
    updateSystemItem(updatedSystem: SystemItem): void;
}

const initialContextState: ISystemContext = {
    systemItems: [],
    isLoading: false,
    addSystemItem: contextFunctionInit,
    updateSystemItem: contextFunctionInit
};

export const SystemContext = createContext<ISystemContext>(initialContextState);
